import { FormStructure } from '@europrocurement/flexy-form/components';
import { jsonDateInput } from '../types/formTypes';
import { checkFieldValue } from '../functions';

const jsonDateInputToFormElement: (input: jsonDateInput) => FormStructure = (input) => {
    const baseField: FormStructure = {
        type: input.type,
        name: input.name,
        inputlabel: input.inputlabel,
        placeholder: input.placeholder,
        inputProps: {
            startAdornment: input.startAdornment,
            endAdornment: input.endAdornment,
        },
        xs: input.xs,
        sm: input.sm,
        md: input.md,
        lg: input.lg,
        sx: {
            fontSize: '14px',
            marginTop: '15px',
            marginBottom: '15px',
            fontWeight: '500',
        },
        tooltip: input.tooltip,
    };

    // comportement sur rules copyValueTo
    if (input.rules && input.rules.copyValueTo) {
        baseField.onChangeInput = (e, inputPath, formContextOnChangeInput) => {
            const fieldToCopyTo = input.rules.copyValueTo as string;
            formContextOnChangeInput.setValue(fieldToCopyTo, e);
        };
    }

    // comportement sur rules display
    if (input.rules && input.rules.display) {
        if (input.rules.display.fieldIsEqualTo) {
            const fieldNameToWatch = input.rules.display.fieldIsEqualTo.field;
            const valueToWatch = input.rules.display.fieldIsEqualTo.value;

            baseField.display = (formContext: UseFormReturn<FieldValues, FormObject>) =>
                checkFieldValue(formContext, valueToWatch, fieldNameToWatch);
        }
        if (input.rules.display.fieldIsNotEqualTo) {
            const fieldNameToWatch = input.rules.display.fieldIsEqualTo.field;
            const valueToWatch = input.rules.display.fieldIsEqualTo.value;

            baseField.display = (formContext: UseFormReturn<FieldValues, FormObject>) =>
                !checkFieldValue(formContext, valueToWatch, fieldNameToWatch);
        }
        if (input.rules.display.isTrue) {
            const fieldNameToWatch = input.rules.display.isTrue;

            baseField.display = (formContext: UseFormReturn<FieldValues, FormObject>) =>
                checkFieldValue(formContext, true, fieldNameToWatch);
        }
        if (input.rules.display.fieldIsChecked) {
            const fieldNameToWatch = input.rules.display.fieldIsChecked;

            baseField.display = (formContext: UseFormReturn<FieldValues, FormObject>) =>
                checkFieldValue(formContext, true, fieldNameToWatch);
        }
        if (input.rules.display.fieldIsNotChecked) {
            const fieldNameToWatch = input.rules.display.fieldIsNotChecked;

            baseField.display = (formContext: UseFormReturn<FieldValues, FormObject>) =>
                checkFieldValue(formContext, false, fieldNameToWatch);
        }
    }

    return baseField;
};

export default jsonDateInputToFormElement;
